import React from "react";
import { motion } from "framer-motion";

export default function ProgressBar({ value = 0, max = 100, testid = "progress-bar", showLabel = false }) {
  const pct = Math.min(100, Math.round((value / Math.max(1, max)) * 100));
  return (
    <div className="w-full" data-testid={testid}>
      <div className="w-full h-2.5 bg-white/5 rounded-full overflow-hidden border border-white/10">
        <motion.div
          className="h-full bg-gradient-to-r from-[#E50914] via-[#F6121D] to-[#FF9F0A] shadow-[0_0_10px_rgba(229,9,20,0.5)]"
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
        />
      </div>
      {showLabel && (
        <div className="mt-2 flex justify-between text-xs text-zinc-400 font-medium">
          <span>{value.toLocaleString()} likes</span>
          <span>{max.toLocaleString()} goal</span>
        </div>
      )}
    </div>
  );
}
